import {Hash} from "~/interfaces/hashInterfaces";
import Enum from "~/interfaces/enum";

interface Enumerable {
  [key: number]: string;
}

// an enum with only number values, returns hash with values as keys
export function generateEnumHash(enumClass, method: (keyVal, attr: string) => Hash, attr: string) {
  const base = {};
  Object.keys(enumClass).filter(e => Number(e)).forEach(k => {
    base[k] = method(k, attr)
  })
  return base;
}

export let EnumHelper = {
  toArray: function (e: Enumerable): Array<number> {
    return Object.keys(e).reduce((keys, currentKey) => {
      const k = parseInt(currentKey, 10);
      if (!isNaN(k)) {
        keys.push(k);
      }
      return keys;
    }, []);
  },
  toArrayOfPairs: function (e: Enumerable): Array<{id: number, name: string}> {
    const map = [];
    for (let val in e) {
      if (typeof e[val] === 'number') {
        map.push({id: e[val], name: val})
      }
    }
    return map
  },
  parseStringValue(stringValue: string, enumConstant: Enum): (keyof Enum | null) {
    // needs to reject GUIDs at least
    if (!stringValue || stringValue.length > 5) { return null; }

    const num = Number(stringValue);
    if (!Number.isInteger(num)) { return null; }

    // trying to avoid returning undefined
    if (num in enumConstant) {
      return num;
    } else {
      return null;
    }
  }
};
